import { isTomorrow, parseISO } from "date-fns";

//schedule rtemplate
let schedule = {
    "_id": "69cbf44073ba07b34287286a",
    "uid": "61442a17a6566a001623bf20",
    "date": new Date().toISOString(),
    "breakMin": 60,
    "company": "Sparkle Star International - Inhouse",
    "createdAt": "2026-03-31T16:20:16.485Z",
    "from": "08:00",
    "name": "Sparkle Demo",
    "nightdiff": 0,
    "otHours": 0,
    "position": "Demo",
    "restday": 0,
    "to": "05:00",
    "totalHours": "20",
    "updatedAt": "2026-04-19T23:06:18.161Z",
    "confirmed": false
}

export function getCurrentSchedule(date) {

    if (!date)
        return [schedule]

    // If the date is tomorrow compared to schedule.date
    if (date && isTomorrow(parseISO(date), { locale: undefined })) {

        let newDate = new Date(schedule.date)
        newDate.setDate(newDate.getDate() + 1)
        newDate.setUTCHours(0, 0, 0, 0)
        console.log('new date', newDate.toISOString())

        let updatedSchedule = {
            ...schedule,
            date: newDate.toISOString(),
            confirmed: false
        }
        return [updatedSchedule]
    }

    return [schedule]
}

export function confirmSchedule() {
    schedule = {
        ...schedule,
        confirmed: true
    }
    return schedule
}


//api/schedule/batch
export function batchUpdateSchedule() {
    return {
        "success": true,
        "msg": "Schedules updated: 1 record(s) for 1 employee(s).",
        "data": {
            "updated": [
                {
                    "uid": "69854fbe6dc06900705a2108",
                    "date": "04/22/2026"
                }
            ],
            "updatedCount": 1,
            "uniqueEmployeeCount": 1,
            "failed": []
        }
    }
}


export function getSchedule() {
    return {
        "success": true,
        "filteredRecords": [
            {
                "_id": "69cbf44073ba07b342872881",
                "emp": "Sparkle Demo",
                "position": "Developer",
                "date": new Date().toISOString(),
                "startShift": "08:00",
                "endShift": "05:00",
                "breakMin": 60,
                "totalHours": "20",
                "otHours": 0,
                "nightdiff": 0,
                "restday": 0,
                "timeIn": 0,
                "timeOut": 0
            },
        ]
    }
}

//api/schedule/61442a17a6566a001623bf20
export function getUserSchedule() {
    return [
        {
            "_id": "69f7da3565d415dc4edf6e9b",
            "date": "2026-05-29T00:00:00.000Z",
            "uid": "61442a17a6566a001623bf20",
            "breakMin": 60,
            "company": "Sparkle Star International - Inhouse",
            "createdAt": "2026-05-03T23:28:53.491Z",
            "from": "08:00",
            "name": "Jeffrey Pareja",
            "nightdiff": 0,
            "otHours": 0,
            "position": "Developer",
            "restday": 0,
            "to": "17:00",
            "totalHours": "8",
            "updatedAt": "2026-05-05T02:37:27.067Z"
        },
        {
            "_id": "69f7da3565d415dc4edf6e9a",
            "date": "2026-05-28T00:00:00.000Z",
            "uid": "61442a17a6566a001623bf20",
            "breakMin": 60,
            "company": "Sparkle Star International - Inhouse",
            "createdAt": "2026-05-03T23:28:53.491Z",
            "from": "08:00",
            "name": "Jeffrey Pareja",
            "nightdiff": 0,
            "otHours": 0,
            "position": "Developer",
            "restday": 0,
            "to": "17:00",
            "totalHours": "8",
            "updatedAt": "2026-05-05T02:37:27.067Z"
        },
        {
            "_id": "69f7da3565d415dc4edf6e99",
            "date": "2026-05-27T00:00:00.000Z",
            "uid": "61442a17a6566a001623bf20",
            "breakMin": 60,
            "company": "Sparkle Star International - Inhouse",
            "createdAt": "2026-05-03T23:28:53.491Z",
            "from": "08:00",
            "name": "Jeffrey Pareja",
            "nightdiff": 0,
            "otHours": 0,
            "position": "Developer",
            "restday": 0,
            "to": "17:00",
            "totalHours": "8",
            "updatedAt": "2026-05-05T02:37:27.067Z"
        },
    ]
}